<template>
  <div class="pageContainer">
    <base-card :option="cardOption">
      <div slot="cardBody">
        <div class="container">
          <div class="left">
            <zm-tree style="min-width: 260px" ref="zmTree" @setFormData="setFormData" @setFormType="setFormType" @clearForm="clearForm">
            </zm-tree>
          </div>
          <div class="right">
            <div class="contentContainer">
              <zm-form style="min-width: 600px" ref="zmForm" @refreshTree="refreshTree"></zm-form>
            </div>
          </div>
        </div>
      </div>
    </base-card>
  </div>
</template>

<script>
import zmTree from './modules/zm-tree'
import zmForm from './modules/zm-form'
import editModal from './modules/editModal'
import searchForm from './modules/searchForm'
import baseCard from '@/CrComponents/Card/Card'
export default {
  name: 'ConfigList',
  mounted () {
  },
  computed: {},
  components: {
    zmTree,
    zmForm,
    editModal,
    searchForm,
    baseCard
  },
  data () {
    return {
      showLine: true,
      showIcon: true,
      selectedKeys: [],
      // card相关属性设置
      cardOption: {},
      // 搜索form中的参数
      searchFormModel: {},
      // 所有搜索条件 包括分页，搜素框，表格上筛选条件
      searchModel: {},
      // 表格中的查询条件
      searchTableModel: {},
      // 高级搜索 展开/关闭
      searchInput: null,
      searchText: '',
      selectedRows: [],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {
          this.selectedRows = selectedRows
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
          this.selectedRows = selectedRows
        }
      },
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      table: {
        data: [],
        columns: [{
          title: '名称',
          dataIndex: 'name'

        }, {
          title: '线路',
          dataIndex: 'lineId'

        }, {
          title: '车次表',
          dataIndex: 'timetableId'

        }, {
          title: '最小休息时间',
          dataIndex: 'minBreak'

        }, {
          title: '最大休息时间',
          dataIndex: 'maxBreak'

        }, {
          title: '用餐最小时间',
          dataIndex: 'minMeal'

        }, {
          title: '用餐最大时间',
          dataIndex: 'maxMeal'

        }, {
          title: '最大连续驾驶时间',
          dataIndex: 'maxDriver'

        }, {
          title: '中餐开始时间',
          dataIndex: 'noonMealS'

        }, {
          title: '中餐结束时间',
          dataIndex: 'noonMealE'

        }, {
          title: '晚餐开始时间',
          dataIndex: 'nightMealS'

        }, {
          title: '晚餐结束时间',
          dataIndex: 'nightMealE'

        }, {
          title: '早班开始时间',
          dataIndex: 'startMin'

        }, {
          title: '白班开始时间',
          dataIndex: 'startNoon'

        }, {
          title: '晚班开始时间',
          dataIndex: 'startNight'

        }, {
          title: '整备时间',
          dataIndex: 't1'

        }, {
          title: '从车辆段出发需要准备的时间',
          dataIndex: 't2'

        }, {
          title: '工作时间上限',
          dataIndex: 'tk'

        }, {
          title: '乘务任务结束时所可能产生的最大弹性值',
          dataIndex: 'tp'

        }, {
          title: '加班时间成本',
          dataIndex: 'c2'

        }, {
          title: '操作',
          scopedSlots:
              {
                customRender: 'actions'
              }
        }],
        searchCondition: {},
        loading: false,
        filteredInfo: null,
        sortedInfo: null
      }
    }
  },
  methods: {
    // 清空表单
    clearForm () {
      this.$refs.zmForm.clearForm()
    },
    refreshTree () {
      this.$refs.zmTree.initTreeData()
    },
    // 设置form类型
    setFormType (type) {
      this.$refs.zmForm.setType(type)
    },
    // 设置右边参数
    setFormData (item) {
      this.$refs.zmForm.setValue(item)
    }
  }
}
</script>

<style scoped lang="less">
  .pageContainer{
    .contentContainer{
      padding: 20px;
    }
  }
  .nodeItem{
    display: flex;
    .title{
      flex: 1;
    }
    .action{
      width:80px
    }
  }
  .container{
    display: flex;
    .left{
      min-width: 260px;
    }
    .right{
      flex: 1;
    }
  }
</style>
